export let devplus = {
    body: document.querySelector( 'body' ),
    html: document.querySelector( 'html' ),
    wrapper: document.querySelector( '.wrapper' )
};